/* Function that checks for deep equality between two objects.
Lodash provides this functionality, but this is 20% the size of lodash.
Code is standard deep comparison code, taken from https://medium.com/@stheodorejohn/javascript-object-deep-equality-comparison-in-javascript-7aa227e889d4
A similar method can be found https://stackoverflow.com/questions/25456013/javascript-deepequal-comparison*/

export function checkObjectDeepEquality(obj1: Object, obj2: Object) {
    if (obj1 === obj2) {
        return true;
    }

    if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
        return false;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (!keys2.includes(key) || !checkObjectDeepEquality(obj1[key], obj2[key])) {
            return false;
        }
    }

    return true;
}
